import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminApi, setToken } from './api';
import { useAdminMeta } from './useAdminMeta';

export default function AdminLogin() {
  useAdminMeta('Вход');
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { token } = await adminApi.login(password);
      setToken(token);
      navigate('/admin', { replace: true });
    } catch (err) {
      setError(err.message || 'Не получилось войти');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dark-login" data-testid="admin-login-root">
      <form onSubmit={onSubmit} className="dark-login-card" data-testid="admin-login-form">
        <div data-testid="dark-login-card">
        <div className="flex justify-center mb-5">
          <span style={{ display: 'inline-block', width: 48, height: 1, background: 'var(--gold)' }} />
        </div>
        <h1 className="dark-h1" data-testid="admin-login-title">
          Кабинет<br/>Светланы
        </h1>
        <p style={{ color: 'var(--cream-mute)', fontSize: 14, marginTop: 14 }}>
          Введите пароль, чтобы войти
        </p>

        <div style={{ marginTop: 30 }}>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="пароль"
            autoFocus
            className="dark-input"
            data-testid="admin-login-password"
          />
          {error && (
            <p style={{ marginTop: 12, fontSize: 13, color: 'var(--wine-bright)' }} data-testid="admin-login-error">
              {error}
            </p>
          )}
        </div>

        <button
          type="submit"
          disabled={loading || !password}
          className="dark-btn dark-btn-primary"
          style={{ width: '100%', marginTop: 22, justifyContent: 'center', padding: '14px 22px' }}
          data-testid="admin-login-submit"
        >
          {loading ? 'Минуточку…' : 'Войти'}
        </button>

        <p style={{ marginTop: 28, fontSize: 12, color: 'var(--cream-soft)', fontStyle: 'italic' }}>
          Это ваш закрытый кабинет — посетители сюда не попадут
        </p>
        </div>
      </form>
    </div>
  );
}
